import React from "react";

const soumya_pachpor = () => {
  return (
    <div>
      <h1>Soumya Pachpor</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There was no specific shortlisting criteria. The process was open for
        all branches.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />1 Aptitude round ( July 27th ) + 3 Interview rounds (August 2nd)
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
      </p>

      <p>
        <strong>MCQs on:</strong>
      </p>

      <ul>
        <li>Operating Systems </li>
        <li>OOP </li>
        <li>DBMS </li>
        <li>DSA </li>
        <li>Geometry, Vector Algebra, Matrix Operations </li>
        <li>Logical Reasoning</li>
      </ul>

      <p>
        <strong>Coding Section:</strong>
      </p>

      <ul>
        <li>3 DSA-based coding questions</li>
      </ul>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        29 students shortlisted (July 30th)
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
      </p>

      <p>
        Interviews were conducted on <strong>2nd August</strong>, so there was a
        short gap.
        <br />
        <strong>During this period I focused on:</strong>
      </p>

      <ul>
        <li>Reading about Goldman Sachs and its current projects </li>
        <li>Revising FAQs of OS, DBMS, CN </li>
        <li>Practicing puzzles from GeeksforGeeks</li>
      </ul>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were a total of 3 Rounds (all technical)
        <br />
        Round 1 (45–50 mins)
        <br />
        Focus: DSA + Projects + (little bit of extracurricular)
      </p>

      <ul>
        <li>
          DSA questions were easy, but follow-up questions on optimization and
          alternative solutions were tricky.{" "}
        </li>
        <li>
          Project discussion: drew flow diagram, wrote payloads for queries,
          discussed web scraping.
        </li>
      </ul>

      <p>
        Round 2: (1hr)
        <br />
        This round was totally different from the first round. The interviewer
        asked “What is your favourite subject?” I answered “Mathematics”.
        <br />
        He asked me questions on Probability statistics, Permutation &amp;
        Combination, at first they were intermediate but as we progressed
        further he increased the level. Then we had a very long discussion on
        Trees(what, why, how, types), it was more on philosophical discussion.
        <br />
        Then began the Technical interview, I was asked questions on graphs,
        Dijkstra, Bellman-Ford algo, etc. Next was to implement concepts of
        Permutation using recursion (pseudocode){" "}
      </p>

      <p>Round 3 (50mins):</p>

      <p>
        Pure DSA: Given a situation and had to design a custom data structure
        and algorithm. Continuous follow-up questions and improvements.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        DSA was the main focus.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        GFG notes, code help by babbar is really nice for dbms and os revision
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Start your prep early, try to solve quality questions, I’d suggest you
        to follow a structured list of questions like Strivers A2Z sheet.
        <br />
        Focus more on the logic of the questions/solutions.
        <br />
        If stuck on a question, try to solve it for a day or two, if not able to
        solve look for solutions(3-4 solutions), try to find what were you
        lacking and note it down.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Round 1 (15mins) Project discussion, I was asked to describe my
        work/experience in PSF(web &amp; tech) (as mentioned in my resume).
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?
      </p>

      <ul>
        <li>GS focuses heavily on problem solving and approach. </li>
        <li>
          DSA is the most important skill, keep your focus on the implementation
          of data structures (this will help you in designing your own data
          structure and algorithm).{" "}
        </li>
        <li>
          Be well-prepared for Round 2 : your favourite subject/domain will be
          tested deeply.
        </li>
      </ul>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <p>
        Keep smiling 😀 and be confident, the interview process can be
        exhausting, so don’t get disheartened. Stay calm, be consistent, and
        give your absolute best in every round. Lastly, avoid comparing yourself
        with others, everyone learns and grows at their own pace, and each
        person has a unique path to success.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong>{" "}
        <a href="mailto:pachporsoumya0@gmail.com">pachporsoumya0@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/soumya-pachpor-7ba9a6289/"> Soumya Pachpor</a>
      </p>
    </div>
  );
};

export default soumya_pachpor;
